import React from 'react'
// components
import TableManagementProvider from 'containers/Search/layers/BL'
import Security from 'components/PageComponents/Settings/Security'

const SecurityContainer: React.FC = () => (
  <TableManagementProvider>
    <Security />
  </TableManagementProvider>
)

export default SecurityContainer
